(() => {
  const announcer = document.getElementById('a11y-variant-announcer');
  if (!announcer) return;

  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  let lastVariantId = null;
  let lastMessage = '';
  let pendingTimer = null;

  document.addEventListener('on:variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;

    const variantId = String(variant.id);
    if (variantId === lastVariantId) return;

    const parts = [];
    if (variant.title) parts.push(`Variant updated to ${variant.title}.`);
    if (typeof variant.price === 'number') {
      const formatted = (variant.price / 100).toLocaleString('en-US', {
        style: 'currency',
        currency,
      });
      parts.push(`Price ${formatted}.`);
    }
    if (variant.sku) parts.push(`SKU ${variant.sku}.`);

    const message = parts.join(' ');
    if (!message || message === lastMessage) return;

    lastVariantId = variantId;
    lastMessage = message;

    if (pendingTimer) {
      clearTimeout(pendingTimer);
      pendingTimer = null;
    }
    announcer.textContent = '';
    pendingTimer = setTimeout(() => {
      announcer.textContent = message;
      pendingTimer = null;
    }, 50);
  });
})();
